import React, { useState, useRef, useEffect, forwardRef } from "react";
import styles from "./VideoTrimmer.module.css";
import VideoPreview from "./VideoPreview";

const VideoCrop = forwardRef(
  (
    {
      onCropChange,
      videoUrl,
      trimSettings,
      rotation,
      handleVideoLoad,
      onVideoDataLoaded,
      hasVideoPoster,
    },
    ref
  ) => {
    const [crop, setCrop] = useState({ x: 0, y: 0, width: 100, height: 100 });
    const cropBoxRef = useRef(null);
    const [videoWidth, setVideoWidth] = useState(0);
    useEffect(() => {
      if (ref.current) {
        setVideoWidth(ref.current.clientWidth);
      }
      if (onCropChange) {
        const video = ref.current;
        if (video && video.videoWidth > 0) {
          const scaleX = video.videoWidth / video.clientWidth;
          const scaleY = video.videoHeight / video.clientHeight;
          onCropChange({
            x: Math.round(crop.x * scaleX),
            y: Math.round(crop.y * scaleY),
            width: Math.round(crop.width * scaleX),
            height: Math.round(crop.height * scaleY),
          });
        }
      }
    }, [crop, onCropChange, ref]);

    const handleMouseDown = (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startY = e.clientY;
      const startWidth = crop.width;
      const startHeight = crop.height;
      const startLeft = crop.x;
      const startTop = crop.y;

      const handleMouseMove = (moveEvent) => {
        const video = ref.current;
        if (!video) return;

        const dx = moveEvent.clientX - startX;
        const dy = moveEvent.clientY - startY;

        if (e.target.classList.contains(styles.crop_handle)) {
          setCrop((c) => ({
            ...c,
            width: Math.min(
              Math.max(20, startWidth + dx),
              video.clientWidth - c.x
            ),
            height: Math.min(
              Math.max(20, startHeight + dy),
              video.clientHeight - c.y
            ),
          }));
        } else {
          setCrop((c) => ({
            ...c,
            x: Math.min(
              Math.max(0, startLeft + dx),
              video.clientWidth - c.width
            ),
            y: Math.min(
              Math.max(0, startTop + dy),
              video.clientHeight - c.height
            ),
          }));
        }
      };

      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };

    return (
      <div className={styles.crop_container}>
        <VideoPreview
          ref={ref}
          videoUrl={videoUrl}
          trimSettings={trimSettings}
          rotation={rotation}
          onVideoLoad={handleVideoLoad}
          onVideoDataLoaded={onVideoDataLoaded}
          hasVideoPoster={hasVideoPoster}
          className={styles.crop_video}
        />
        <div
          ref={cropBoxRef}
          className={styles.crop_box}
          style={{
            transform: `translate(${crop.x - videoWidth / 2}px, ${crop.y}px)`,
            width: `${crop.width}px`,
            height: `${crop.height}px`,
          }}
          onMouseDown={handleMouseDown}
        >
          <div className={`${styles.crop_handle} ${styles.crop_handle_br}`} />
        </div>
      </div>
    );
  }
);

export default VideoCrop;
